import React from 'react';
import classNames from 'classnames';
import Plan from '../plan';
import PlanLabel from '../plan-label';
import HangingTag from '../hanging-tag';
import noop from '../../../../utils/noop';
const defaultCaptions = {};

const PlanDesktop = ({
  captions = defaultCaptions,
  highlighted = false,
  limited = false,
  disabled = false,
  isLoading = false,
  onPlanSelect = noop,
  type,
  withIntroPriceDiscounts = false,
}) => {
  const { label, tagLabel } = captions;
  const classes = classNames('ws-ui-plan-desktop', {
    'ws-ui-plan-desktop--highlighted': highlighted,
    'ws-ui-plan-desktop--disabled': disabled,
  });

  return (
    <div className={classes}>
      {limited && (
        <div className="ws-ui-plan-desktop__tag-wrapper">
          <HangingTag label={tagLabel} animated />
        </div>
      )}
      <PlanLabel highlighted={highlighted} label={label} limited={limited} />
      <Plan
        captions={captions}
        onPlanSelect={onPlanSelect}
        isLoading={isLoading}
        disabled={disabled}
        highlighted={highlighted}
        limited={limited}
        type={type}
        withIntroPriceDiscounts={withIntroPriceDiscounts}
      />
    </div>
  );
};

export default PlanDesktop;
